import { render, staticRenderFns } from "./Koutu_Step_QuickChop.vue?vue&type=template&id=2ee11479&scoped=true"
import script from "./Koutu_Step_QuickChop.vue?vue&type=script&lang=js"
export * from "./Koutu_Step_QuickChop.vue?vue&type=script&lang=js"
import style0 from "./Koutu_Step_QuickChop.vue?vue&type=style&index=0&id=2ee11479&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee11479",
  null
  
)

export default component.exports